module.exports = __webpack_public_path__ + "assets/img/ecg-detail-back-banner1.b91d812e.png";